export enum ContactType {
  Email = 'EMAIL',
  Mobile = 'MOBILE',
  Fax = 'FAX',
  Phone = 'PHONE',
  WhatsApp = 'WHATSAPP',
  Foreign = 'FOREIGN',
}

export const contactTypeOptions = [
  { value: ContactType.Email, label: 'E-mail' },
  { value: ContactType.Mobile, label: 'Celular' },
  { value: ContactType.Fax, label: 'Fax' },
  { value: ContactType.Phone, label: 'Telefone' },
  { value: ContactType.WhatsApp, label: 'Whatsapp' },
  { value: ContactType.Foreign, label: 'Estrangeiro' },
];

export const contactTypeTranslate = {
  [ContactType.Email]: 'E-mail',
  [ContactType.Mobile]: 'Celular',
  [ContactType.Fax]: 'Fax',
  [ContactType.Phone]: 'Telefone',
  [ContactType.WhatsApp]: 'Whatsapp',
  [ContactType.Foreign]: 'Estrangeiro',
};
